// extracted by css-extract-rspack-plugin
export default {"cards":"R2ChO3m_fLMlKvt7","card":"zYQtjnaRGIn3efk3","label":"re4JxRcnLKQ_ET2r","count":"akoGDtRfEkrPnpE0","iconGreen":"DdvLKDNxvaQsnaoo","iconAmber":"hO9KNWhV1oDEjgNt"};